/* istanbul ignore file */
export default [
  {
    path: '/survey/responses',
    name: 'surveyResponse',
    component: () => import('../views/SurveyResponse'),
    meta: {
      auth: true,
      anyCan: { survey: 'read' }
    }
  },
  {
    path: '/survey/groups',
    name: 'surveyGroups',
    component: () => import('../views/SurveyGroup'),
    meta: {
      auth: true,
      anyCan: { survey: 'read' }
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard'),
    meta: {
      auth: true,
      anyCan: { survey: 'read' }
    }
  }

]
